import React from "react";
import DocumentTitle from "react-document-title";
import { BrandName } from "../../../utilities/constants";

export interface JmTitleProps {
  title: string;
  shouldPrefixBrandName?: boolean;
}

class JmTitle extends React.PureComponent<JmTitleProps> {
  public render() {
    const fullTitle =
      this.props.shouldPrefixBrandName !== false
        ? BrandName
          ? `${this.props.title.toUpperCase()} - ${BrandName}`
          : this.props.title
        : this.props.title;

    return (
      <DocumentTitle title={fullTitle}>{this.props.children}</DocumentTitle>
    );
  }
}

export default JmTitle;
